import styles from './SignatureModal.module.scss';
import ValidateButton from '../UI/ValidateButton';
import Close from '@src/assets/Close.png';
import CodeInput from '../UI/CodeInput';
import { useState } from 'react';
import toast from 'react-hot-toast';
import Loader from '../UI/Loader';

type SignatureModalProps = {
    show: boolean;
    onClose: (value: boolean) => void;
    onValidate: (code: string) => void;
    retrySendCode: () => void;
    isLoading: boolean;
    phoneNumber: string;
}

export default function SignatureModal({ show, onClose, onValidate, retrySendCode, isLoading, phoneNumber}: SignatureModalProps) {
    const [code, setCode] = useState<string>('');
    const [isRetryPending, setIsRetryPending] = useState<boolean>(false);
    const [retryTimer, setRetryTimer] = useState<number | null>(null);

    const _handleRetry = async (e: any) => {
        e.preventDefault();
        if (isRetryPending || retryTimer !== null) return;
        setIsRetryPending(true);
        try {
            retrySendCode();
            let remainingTime = 30;
            setRetryTimer(remainingTime);
            const interval = setInterval(() => {
                remainingTime -= 1;
                setRetryTimer(remainingTime > 0 ? remainingTime : null);
                if (remainingTime <= 0) clearInterval(interval);
            }, 1000);
        } catch (err) {
            toast.error('Une erreur est survenue lors du renvoi du code', { position: 'top-center' });
        } finally {
            setIsRetryPending(false);
        }
    };

    const _onValidate = () => {
        if (code.length === 6) {
            onValidate(code);
            setTimeout(() => {
                setCode('');
            }, 500);
        }
    }

    const handleKeypress = (e: any) => {
        if (e.keyCode === 13) {
            _onValidate();
        }
    };

    if (!show) {
        return null;
    }
    return (
        <div className={styles.modalContainer}>
            <div className={styles.modal}>
                <div className={styles.close} onClick={() => onClose(true)}>
                    <img src={Close} alt="Close" width={14} height={14} />
                </div>
                <div className={styles.title}>Signer votre demande par SMS</div>
                <div className={styles.contentContainer}>
                    <p className={styles.subTitle}>Signature par SMS au {phoneNumber}</p>
                    <p className={styles.description}>Si le numéro n’est pas correct ou bien que vous rencontrez certaines difficultés, merci de nous contacter.</p>
                    <p className={styles.codeTitle}>Saisissez le code envoyé :</p>
                    <div className={styles.codeInputContainer}>
                        <CodeInput fields={6} code={code} setCode={setCode} onKeyPress={handleKeypress} />
                    </div>
                    <p className={styles.description} style={{ marginTop: '10px' }}>
                        Vous n’avez rien reçu ?{' '}
                        <button
                            onClick={_handleRetry}
                            className={styles.buttonLink}
                            style={{
                                color: isRetryPending || retryTimer !== null ? '#333' : '#24B1ED',
                                cursor: isRetryPending || retryTimer !== null ? 'not-allowed' : 'pointer',
                            }}
                            disabled={isRetryPending || retryTimer !== null}
                        >
                            {retryTimer !== null ? `Renvoyer un code dans ${retryTimer}s` : 'Renvoyer un code'}
                        </button>
                    </p>
                    {isLoading ?
                        <div style={{ display: 'flex', justifyContent: 'center' }}><Loader type="SPINNER" /></div>
                        :
                        <div className={styles.buttonDiv}>
                            <ValidateButton title="Continuer" onClick={_onValidate} isSignatureModal onLoading={isLoading} />
                            <ValidateButton title="Annuler" inverted onClick={() => onClose(true)} isInvertedSignatureModal onLoading={isLoading} />
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}
